import { useQuery } from '@tanstack/react-query';
import peopleService from '@/lib/api/people';
import type { PeopleFilters } from '@/lib/api/people';

export function usePeopleList(
  organizationId: string | undefined,
  options?: PeopleFilters & { enabled?: boolean },
) {
  const query = useQuery({
    queryKey: [
      'people',
      organizationId,
      options?.limit,
      options?.offset,
      options?.search,
      options?.buying_intent,
      options?.qualification_status,
      options?.source,
      options?.date_from,
      options?.date_to,
    ],
    queryFn: async () => {
      if (!organizationId) throw new Error('Organization ID required');

      const response = await peopleService.getPeopleList(organizationId, {
        limit: options?.limit,
        offset: options?.offset,
        search: options?.search,
        buying_intent: options?.buying_intent,
        qualification_status: options?.qualification_status,
        source: options?.source,
        date_from: options?.date_from,
        date_to: options?.date_to,
      });

      if (!response.success || !response.data) {
        throw new Error(response.error || 'Failed to fetch people');
      }

      return response.data;
    },
    enabled: !!organizationId && (options?.enabled ?? true),
    staleTime: 30 * 1000,
  });

  return {
    people: query.data?.people || [],
    total: query.data?.total || 0,
    isLoading: query.isLoading,
    error: query.error,
  };
}
